import React, { useState, useEffect } from 'react';
import { myparticipate } from '../functions/user';
import Post from "../components/post/Post";
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles(theme => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: '20px',
        marginBottom: '20px',
    },

}));

const MyPost = () => {

    const styles = useStyles();

    const { user: { userID }, mypage: { type } } = useSelector(state => ({ ...state }));

    const [list, setList] = useState([]);

    //  const userID = "2018142226@yonsei.ac.kr";
    // const type = 0;

    useEffect(() => {
        myparticipate(userID, type).then(res => {
            setList([...res]);
        }).catch(err => {
            console.log(err);
        });
    }, []);

    return (
        <div className={styles.container}>
            {
                list.map((item, index) => {
                    return <Post
                        key={index}
                        title={item.title}
                        content={item.content}
                        date={item.date}
                        deadline={item.deadline}
                        done={item.done}
                        comments={item.comments}
                        author={item.author}
                        author_info={item.author_info}
                        goal_participants={item.goal_participants}
                        participants={item.participants}
                        target={item.target}
                        with_prize={item.with_prize}
                        prize={item.prize}
                        num_prize={item.num_prize}
                        credit={item.credit}
                        num_credit={item.num_credit}
                    />
                }
                )
            }
        </div>
    );
};

export default MyPost;